import React, { Component } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF, toPercentage, toCurrencyLocale } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class TerminalItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode } = this.props

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.defaultGroup ? 'Yes' : 'No'}
            checked={data.defaultGroup}
            editMode={editMode}
            onChange={this.onChange('defaultGroup', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enablePromotion ? 'Enabled' : 'Disabled'}
            checked={data.enablePromotion}
            editMode={editMode}
            onChange={this.onChange('enablePromotion', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.discountType}
            onChange={this.onChange('discountType')}
            valueToRender={data.discountType}
            editMode={editMode && !data.enablePromotion}
          >
            <MenuItem value="Cash">Cash</MenuItem>
            <MenuItem value="Percentage">Percentage</MenuItem>
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={
              data.discountType === 'Percentage'
                ? toPercentage(data.discount || 0)
                : toCurrencyLocale(data.discount || 0)
            }
            editMode={editMode && !data.enablePromotion}
            value={data.discount}
            onChange={this.onChange('discount')}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MemberGroups/MemberGroupItem.js